export default "__VITE_PUBLIC_ASSET__990e38b5__"